import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getFullName, formatDate } from '../helpers'
import { LIST_TYPE, ROUTES } from '../constant'
import { getClients } from '../actions/admin'
import { exportRejected } from '../actions/export'
import Breadcrumb from '../components/Breadcrumbs'
import TableAutomation from '../components/TableAutomation'


class ListClients extends Component {
  /* LIFECYCLE */

  state = {
    lastQuery: '',
    lastOptions: {},
  }


  /* METHODS */

  handleItemClick = (item) => {
    this.props.history.push(`${ROUTES.CLIENTS}/${item.objectID}`)
  }

  handleGetClients = (query, options) => {
    const { list } = this.props

    this.props.getClients(query, {
      sort: list.sort || '',
      ...options,
    })

    this.setState({
      lastQuery: query,
      lastOptions: options,
    })
  }

  handleSortChange = (sort) => {
    const { lastQuery, lastOptions } = this.state

    return this.handleGetUsers(lastQuery, {
      ...lastOptions,
      sort,
    })
  }



  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      list,
      isLoading,
      isConnected,
    } = this.props

    return (
      <div>
        <Breadcrumb
          data={[
            { label: 'Home', to: ROUTES.HOME },
            'Clients',
          ]}
        />

        <TableAutomation
          onClick={this.handleItemClick}
          request={this.handleGetClients}
          head={[
            { label: 'Name', sort: 'lastname' },
            { label: 'Email', sort: 'email' },
            { label: 'Registration date', sort: 'created_at' },
            { label: 'Castings', sort: 'castings_count' },
          ]}
          row={client => ([
            getFullName(client),
            client.email,
            formatDate(client.created_at),
            client.castings_count || 0,
          ])}
          {...list}
        />
      </div>
    )
  }
}


ListClients.propTypes = {
  list: PropTypes.object,
  isConnected: PropTypes.bool,
  exportRejected: PropTypes.func,
  getClients: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  isConnected: state.user.isConnected,
  list: state.list.collection === LIST_TYPE.CLIENT ? state.list : {
    page: 0,
    count: 0,
    sort: '',
    items: [],
    totalPages: 0,
  },
})


export default connect(mapStateToProps, {
  getClients,
  exportRejected,
})(ListClients)
